// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"collapsible__wrapper___1lDSi","text_wrapper":"collapsible__text_wrapper___3utrh","short_text":"collapsible__short_text___2f7Aq","show_more":"collapsible__show_more___3jV7o","toggle_wrapper":"collapsible__toggle_wrapper___2mq_r"};
    if(module.hot) {
      // 1665497109324
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  